import { actionSet } from './utils'
import {
  FETCH_DEPOSIT_APPROVAL_REQUEST,
  FETCH_DEPOSIT_APPROVAL_SUCCESS,
  FETCH_DEPOSIT_APPROVAL_ERROR,
  UPDATE_DEPOSIT_APPROVAL_REQUEST,
  UPDATE_DEPOSIT_APPROVAL_SUCCESS,
  UPDATE_DEPOSIT_APPROVAL_ERROR,
} from 'actionTypes'
import ApiRequest from 'utils/ApiRequest'
import api from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'

export const fetchDepositApprovalList = (token, filters = {}) => async (dispatch) => {
  try {
    dispatch(showSpinner())
    dispatch(actionSet(FETCH_DEPOSIT_APPROVAL_REQUEST))
    
    const apiRequest = new ApiRequest(token, dispatch)
    
    const queryParams = {
      // Default pagination parameters
      page: filters.page !== undefined ? filters.page : 0,
      size: filters.size !== undefined ? filters.size : 10
    }
    
    // Filter parameters
    if (filters.sourceWarehouses && filters.sourceWarehouses.length > 0) {
      queryParams.sourceWarehouses = filters.sourceWarehouses
    }
    
    if (filters.destinationWarehouses && filters.destinationWarehouses.length > 0) {
      queryParams.destinationWarehouses = filters.destinationWarehouses
    }
    
    if (filters.requiresApproval !== undefined && filters.requiresApproval !== null) {
      queryParams.requiresApproval = filters.requiresApproval
    }
    
    const response = await apiRequest.get(api.WAREHOUSE_APPROVALS_FIND, queryParams)
    
    dispatch(hideSpinner())
    return dispatch(actionSet(FETCH_DEPOSIT_APPROVAL_SUCCESS, response.data))
  } catch (error) {
    dispatch(hideSpinner())
    return dispatch(actionSet(FETCH_DEPOSIT_APPROVAL_ERROR, error))
  }
}

export const updateWarehouseRequiresApproval = (token, idWarehouseApproval, requiresApproval) => async (dispatch) => {
  try {
    dispatch(actionSet(UPDATE_DEPOSIT_APPROVAL_REQUEST, { idWarehouseApproval }))
    
    const apiRequest = new ApiRequest(token, dispatch)
    
    const endpoint = `${api.WAREHOUSE_APPROVALS_UPDATE}/${idWarehouseApproval}/requires-approval?requiresApproval=${requiresApproval}`
    
    const response = await apiRequest.put(endpoint, null)
    
    return dispatch(actionSet(UPDATE_DEPOSIT_APPROVAL_SUCCESS, { idWarehouseApproval, requiresApproval, response: response.data }))
  } catch (error) {
    return dispatch(actionSet(UPDATE_DEPOSIT_APPROVAL_ERROR, { idWarehouseApproval, error }))
  }
}